import axios from "axios";

import { jwtDecode, JwtPayload } from "jwt-decode";
import { API_TRAVITY_URL, API_URL, getPf } from "../utils/conf";
const createAxiosInstance = (baseURL: string) => {
  const axiosInstance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decodedToken = jwtDecode(token) as JwtPayload;
          if (!decodedToken) {
            localStorage.removeItem("token");
            return config;
          }

          if (
            typeof decodedToken === "object" &&
            decodedToken.exp &&
            decodedToken.exp < Date.now() / 1000
          ) {
            localStorage.removeItem("token");
            return config;
          } else {
            config.headers.Authorization = `Bearer ${token}`;
          }
        } catch (error) {
          console.error("Error verifying/decoding token:", error);
          localStorage.removeItem("token");
        }
      }
      return config;
    },
    (error) => {
      if (error.request && error.request.status === 401) {
        const openModalEvent = new CustomEvent("openLoginModal", {
          bubbles: true,
        });
        document.dispatchEvent(openModalEvent);
      }
      return Promise.reject(error);
    },
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error?.response && error?.response?.status === 401) {
        const openModalEvent = new CustomEvent("openLoginModal", {
          bubbles: true,
        });
        document.dispatchEvent(openModalEvent);
      }
      if (error?.response?.data?.code) {
        return Promise.reject(error.response.data);
      }
      return Promise.reject(error);
    },
  );
  return axiosInstance;
};

const axiosInstance = createAxiosInstance(API_URL);
export default axiosInstance;
const axiosTravityInstance = createAxiosInstance(API_TRAVITY_URL);
export { axiosTravityInstance };

export const chooseApi = () => {
  return getPf() === "TRAVITY" ? axiosTravityInstance : axiosInstance;
};
